// #region Imports

import * as $ from 'jquery';
import { LookupEntry } from '../lookupEntry';
import * as Responsiveness from '../ui/responsiveness'

// #endregion Imports

// #region Exports

export function initialize(): void {
    wireScrollEvent();
    wireChangeEvents();
    wireMenuToggler();
}

(window as any)._getElementFromPosition = getElementFromPosition;

// #endregion Exports

// #region Private members

const _activeClass = 'menu__item--active';
const _autoOpenClass = 'menu__item--auto';
let _contentTop: number;
let _currentScrollElement;
let _isFloating:boolean;
let _isRecalculating:boolean;
let _lookupTable: Array<LookupEntry>;
let _fullLookupTable: Array<LookupEntry>;
let _menu;
let _ownHeight;
let _parent;
let _parentStart;
let _parentEnd;
const _scrollOffset = 324;

// #endregion Private members

// #region Private functions

function wireChangeEvents() {
    if(Responsiveness.smallerThan(Responsiveness.TABLET_LANDSCAPE)) {
        return;
    }

    const floatingElements = $('.js-floating');
    if (floatingElements.length === 0) {
        return;
    }

    $(window).resize(recalculateMenu);

    const mainElement = document.getElementById('main');
    if (mainElement != null) {
        const observer = new MutationObserver(handleMutations);
        observer.observe(mainElement, { attributes: true, subtree: true, childList: true });
    }
}

function wireScrollEvent() {
    if(Responsiveness.smallerThan(Responsiveness.TABLET_LANDSCAPE)) {
        return;
    }

    const floatingElements = $('.js-floating');
    if (floatingElements.length === 0) {
        return;
    }

    _menu = $(floatingElements.get(0));
    _parent = _menu.parent();

    recalculateMenu();

    $(window).scroll(updateScrollspy);
}

function wireMenuToggler() {
    $(".menu__toggle").click(toggleMenuItem);
    $(".menu__link:not(.subject-menu-link)").click(propagateToggle)
}

function propagateToggle(e:any) {
    $(this).find('.menu__toggle').click();
}

function toggleMenuItem(e:any) {
    e.preventDefault();
    e.stopPropagation();

    $(this).parent().parent().toggleClass('menu__item--open');
}

function handleMutations(mutations:any) {
    let recalculate = false;
    mutations.forEach(mutation => {
        if (mutation.target.tagName !== "NAV") {
            recalculate = true;
        }
    });

    if (recalculate) {
        recalculateMenu();
    }
}

function recalculateMenu() {
    if (_isRecalculating) {
        return;
    }

    _isRecalculating = true;

    buildLookupTables();

    const $header = $('.header');
    const $menuContainer = $('.menu-container');

    // IE11-fix (ger negativa värden för höjd om elementet överstiger 150000px)
    let innerHeight = _parent.innerHeight();
    if (innerHeight < 0) {
        innerHeight = -innerHeight;
    }

    _contentTop = $header.innerHeight();
    _ownHeight = _menu.outerHeight();
    _parentStart = _parent.offset().top - _contentTop;
    _parentEnd = innerHeight + _parentStart;
    _isFloating = false;

    if (_menu.css('position') == 'sticky') {
        _menu.css('width', 'auto');
    }
    else {
        _menu.css('width', $menuContainer.outerWidth());
    }

    updateScrollspy();

    _isRecalculating = false;
}

function updateScrollspy() {
    const scrollTop = $(window).scrollTop();

    updateMenuPosition(scrollTop);
    highlightChapterInMenu(scrollTop);
}

function updateMenuPosition(scrollTop:number):void {
    if (scrollTop > (_parentStart) && !_isFloating) {
        _menu.removeClass('menu--bottom').addClass('menu--floating');
        _isFloating = true;
    }
    else if (scrollTop <= (_parentStart) && _isFloating) {
        _menu.removeClass('menu--bottom').removeClass('menu--floating');
        _isFloating = false;
    }
    if (_isFloating && (scrollTop + _ownHeight) > _parentEnd) {
        _menu.addClass('menu--bottom').removeClass('menu--floating');
        _isFloating = false;
    }
}

function highlightChapterInMenu(scrollTop: number): void {
    const examModeContainer = document.getElementById("exam-mode-container");
    //console.log(examModeContainer ? "ja" : "nej");

    const scrollPosition = examModeContainer ? scrollTop + _scrollOffset + $("#exam-mode-container").outerHeight() :  scrollTop + _scrollOffset;
    
    for (let i = 0; i < _lookupTable.length; i++) {
        const item = _lookupTable[i];

        if (scrollPosition >= item.from && scrollPosition < item.to) {
            if (item.element !== _currentScrollElement) {
                _currentScrollElement = item.element;
                const id = $(item.element).attr('id');
                $(`.${_activeClass}`).removeClass(_activeClass);
                $(`a[href="#${id}"]`).parent().addClass(_activeClass);
                autoOpenItems(id);
            }

            break;
        }
    }
}

function autoOpenItems(id) {
    $(`.${_autoOpenClass}`).removeClass(_autoOpenClass);
    $(`a[href="#${id}"]`).parents('.menu__item').addClass(_autoOpenClass);
}

function getElementFromPosition(position: number): string {
    if(_fullLookupTable === undefined){
        console.warn("_fullLookupTable is empty");
        buildLookupTables();
    }
    for (let i = 0; i < _fullLookupTable.length; i++) {
        const item = _fullLookupTable[i];

        if (position >= item.from && position < item.to) {
            return $(item.element).attr('id');
        }
    }

    const item = _fullLookupTable[0];
    return $(item.element).attr('id');
}

function buildLookupTables() {
    // Första nivå och utvalda objekt
    _lookupTable = new Array<LookupEntry>();
    buildLookupTable(_lookupTable, 'div.niv1, .node--level2, .js-spyable');

    // Samtliga element i dokument som har id
    _fullLookupTable = new Array<LookupEntry>();
    buildLookupTable(_fullLookupTable, '#documentcontent [id]');
}

function buildLookupTable(lookupTable: Array<LookupEntry>, selector: string) {
    const $elements = $(selector).not('[id^="marking-"]');

    if ($elements.length === 0) {
        return;
    }

    $elements.each((index, element) => {
        const $element = $(element);
        const from = $element.offset().top;
        const to = 99999;
        const entry = new LookupEntry(element, from, to);

        lookupTable.push(entry);
    });

    for (let i = 0; i < lookupTable.length - 1; i++) {
        lookupTable[i].to = lookupTable[i + 1].from;
    }

    if (lookupTable.length > 0) {
        lookupTable[0].from = 0;
    }
}

// #endregion Private functions